import React from 'react';
import { Icon } from 'antd';

import { ModalSto } from 'components/sto';

function CustomModal(props) {
    const defaultSettings = {
        confirmation: { icon: 'info', wrapClassName: 'confirmation-modal' },
        fail: { icon: 'info', wrapClassName: 'failed-modal' },
        success: { icon: 'check', wrapClassName: 'success-modal' },
    };

    return (
        <ModalSto
            buttonSize="large"
            cancelText={props.cancelText}
            isCTA={props.isCTA}
            modalType={props.modalType}
            okText={props.okText}
            onCancel={props.onCancel}
            onOk={props.onOk}
            visible={props.visible}
            wrapClassName={defaultSettings[props.modalType]?.wrapClassName}
        >
            <React.Fragment>
                <Icon type={`${defaultSettings[props.modalType]?.icon}-circle`} />
                {props.children}
            </React.Fragment>
        </ModalSto>
    );
}

export default CustomModal;
